import type { BookingEventArgs } from "~/types/bookingEvents";

export const bookingDataLayerPush = (args: BookingEventArgs) => {
  window.bookingDataLayer = window.bookingDataLayer || [];
  window.bookingDataLayer.push(args);
};
